<template>
  <div class="fab-container">
    <div class="fab-btn" @click="handleClick">
      <img src="img/complete-btn.svg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'fab-button',
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.fab-container {
  position: fixed;
  bottom: 4vh;
  right: 2vh;
  z-index: 1;
}
.fab-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 160px;
  // background: #fff9f5;
  background: #fff;
  border-radius: 50%;/*角丸*/
  opacity: 0.96;
  box-shadow: 2px 4px 6px rgba(0,0,0,0.3);
  overflow: hidden;
}
.fab-btn img {
  width: 100%;
  height: 100%;
}

@media screen and (min-width:480px) {
  .fab-container {
    bottom: 8vh;
    right: 4vh;
  }
  .fab-btn {
    width: 300px;
    height: 300px;
  }
}
</style>
